// extracted by mini-css-extract-plugin
export var Footer = "footer-module--Footer--2MKeI";
export var FooterBox = "footer-module--FooterBox--18dcr";